import {CMSContentType} from "../CMSType";
import {
  TwoColumnContentClubCellDTO,
  TwoColumnContentCellDTO,
  TwoColumnContentRowDTO,
  TwoColumnContentDTO,
  ATwoColumnContentParams,
  TwoColumnContentItemTemplate,
  TwoColumnContentCell,
  TwoColumnContentClubCell,
  ATwoColumnContent,
} from "./two-column.content";

export interface TransfersContentItemParams {
  leftCell,
  rightCell,
}
export interface TransfersContentDTO extends TwoColumnContentDTO {}
export interface TransfersContentRowDTO extends TwoColumnContentRowDTO {}
export interface TransfersContentCellDTO extends TwoColumnContentCellDTO {}
export interface TransfersContentClubCellDTO extends TwoColumnContentClubCellDTO {}

const defaultParams = {
  leftCell: {},
  rightCell: {}
};

export class TransferContentItem extends TwoColumnContentItemTemplate<TwoColumnContentCell, TwoColumnContentClubCell> {
  constructor(row: TransfersContentItemParams = defaultParams ) {
    super();
    const { leftCell, rightCell } = row;
    this.setLeftCell(new TwoColumnContentCell(leftCell.primaryText));
    this.setRightCell(new TwoColumnContentClubCell(rightCell.primaryText, rightCell.avatar, rightCell.record_id));
  }
}

export interface TransferContentParams extends ATwoColumnContentParams <TransferContentItem> {
}

export class TransferContent extends ATwoColumnContent<TransferContentItem> {
  constructor(data: TransferContentParams) {
    super(CMSContentType.transfers, data);
  }

  addRow(row): this {
    return this.push(new TransferContentItem(row));
  }

  setLabel(label: string): this {
    return this._merge({label})
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/transfers.content.ts